const map = {
	"./1x2.png": 82093,
	"./AG_logo_white_hori.png": 45267,
	"./BGaming_logo_bw.png": 19243,
	"./BetSolutions_logo_white.png": 18411,
	"./Iconix_Interactive_logo-01.png": 56591,
	"./Iconix_Interactive_logo_w.png": 80089,
	"./LiveGames_logo_white.png": 36265,
	"./TomHorn.png": 74293,
	"./TurboGames_logo_white.png": 84989,
	"./absolute_live_gaming.png": 7760,
	"./ainsworth.png": 3379,
	"./amatic.png": 13173,
	"./apex.png": 75000,
	"./apollo_games.png": 5133,
	"./aristocrat.png": 33698,
	"./betsoft.png": 65471,
	"./big_time_gaming.png": 75680,
	"./bomba.png": 23435,
	"./booming_games.png": 2617,
	"./booongo.png": 56247,
	"./card-02.png": 96299,
	"./card-03.png": 22146,
	"./card-04.png": 67517,
	"./card-05.png": 46388,
	"./card-06.png": 67855,
	"./card-07.png": 86310,
	"./card-08.png": 14177,
	"./card-09.png": 76696,
	"./card-10.png": 64318,
	"./card-11.png": 82631,
	"./card-12.png": 62572,
	"./casino.png": 63925,
	"./casino2.png": 58019,
	"./egt.png": 37690,
	"./evolution_gaming.png": 44629,
	"./evoplay.png": 57708,
	"./ezugi.png": 57728,
	"./firekirin.png": 42113,
	"./fortuna45/100HPGaming.png": 89827,
	"./fortuna45/1x2Gaming.png": 40721,
	"./fortuna45/3OaksGaming.png": 30959,
	"./fortuna45/3Oaks_3.png": 59754,
	"./fortuna45/7777Gaming.png": 69682,
	"./fortuna45/7mojos.png": 86600,
	"./fortuna45/7mojosGaming.png": 31367,
	"./fortuna45/AbraCadabraGaming.png": 76886,
	"./fortuna45/AbsoluteGaming.png": 50441,
	"./fortuna45/AdLunamGaming.png": 70960,
	"./fortuna45/AirDiceGaming.png": 75039,
	"./fortuna45/AltenteGaming.png": 89931,
	"./fortuna45/AmigoGaming.png": 92951,
	"./fortuna45/AmusnetGaming.png": 13137,
	"./fortuna45/ApparatGaming.png": 4465,
	"./fortuna45/ArmadilloGaming.png": 42079,
	"./fortuna45/AviatrixGaming.png": 34824,
	"./fortuna45/BFGamesGaming.png": 62491,
	"./fortuna45/BGamingGaming.png": 31719,
	"./fortuna45/BWGaming.png": 35159,
	"./fortuna45/BackseatGaming.png": 1740,
	"./fortuna45/BarbarabangGaming.png": 32531,
	"./fortuna45/BeonGaming.png": 33454,
	"./fortuna45/BetOnGamesGaming.png": 55661,
	"./fortuna45/BetSoftGaming.png": 57067,
	"./fortuna45/BigPotGaming.png": 92069,
	"./fortuna45/BigTimeGaming.png": 39239,
	"./fortuna45/BitBloxGaming.png": 4956,
	"./fortuna45/BitvilleGaming.png": 90317,
	"./fortuna45/BoomingGaming.png": 34525,
	"./fortuna45/BooongoGaming.png": 30839,
	"./fortuna45/BullsharkGaming.png": 83372,
	"./fortuna45/CT_InteractiveGaming.png": 74330,
	"./fortuna45/CaletaGaming.png": 41470,
	"./fortuna45/ClawbusterGaming.png": 29856,
	"./fortuna45/CreedroomzGaming.png": 95662,
	"./fortuna45/DreamPlayGaming.png": 3137,
	"./fortuna45/EAGaming.png": 73028,
	"./fortuna45/EGT_DigitalGaming.png": 13323,
	"./fortuna45/Eeze_casinoGaming.png": 94715,
	"./fortuna45/ElaGamesGaming.png": 12039,
	"./fortuna45/EndorphinaGaming.png": 53176,
	"./fortuna45/EspressoGamesGaming.png": 95683,
	"./fortuna45/EvoPlayGaming.png": 79316,
	"./fortuna45/EvolutionGaming.png": 50013,
	"./fortuna45/EzugiGaming.png": 2340,
	"./fortuna45/FancyShoesGaming.png": 72603,
	"./fortuna45/FaziGaming.png": 83374,
	"./fortuna45/FilsGameGaming.png": 26732,
	"./fortuna45/FlipLuckGaming.png": 43156,
	"./fortuna45/FormulaSpinGaming.png": 74652,
	"./fortuna45/GalaxsysGaming.png": 80224,
	"./fortuna45/GameBeatGaming.png": 76524,
	"./fortuna45/GamixGaming.png": 21980,
	"./fortuna45/HabaneroGaming.png": 53542,
	"./fortuna45/HacksawGaming.png": 58868,
	"./fortuna45/Hold'emGaming.jpg": 73226,
	"./fortuna45/HotRiseGames.png": 89822,
	"./fortuna45/Iconic21Gaming.png": 53466,
	"./fortuna45/IconixViatorGaming.png": 29225,
	"./fortuna45/ImaginLiveGaming.png": 8255,
	"./fortuna45/InOutGaming.png": 34981,
	"./fortuna45/IronDogGaming.png": 31490,
	"./fortuna45/JVLGaming.png": 30998,
	"./fortuna45/JetXGaming.png": 10225,
	"./fortuna45/LadyLuckGames.png": 13381,
	"./fortuna45/LeapGaming.png": 66708,
	"./fortuna45/Live88Gaming.png": 98256,
	"./fortuna45/LiveGames.png": 49542,
	"./fortuna45/LiwGames.png": 7252,
	"./fortuna45/MacawGaming.png": 22787,
	"./fortuna45/MancalaGaming.png": 33667,
	"./fortuna45/NetEntGaming.png": 43822,
	"./fortuna45/NetgameGaming.png": 36949,
	"./fortuna45/NolimitCityGaming.png": 67661,
	"./fortuna45/NovomaticGaming.png": 68884,
	"./fortuna45/OneGame.png": 4815,
	"./fortuna45/OnetouchGaming.png": 81567,
	"./fortuna45/PGSoftGaming.png": 82285,
	"./fortuna45/PascalGaming.png": 41874,
	"./fortuna45/PatePlayGaming.png": 85540,
	"./fortuna45/Phoenix7Gaming.png": 89614,
	"./fortuna45/Phoenix7_w.png": 55327,
	"./fortuna45/PixmoveGaming.png": 60890,
	"./fortuna45/PlatinGaming.png": 32928,
	"./fortuna45/PlatinGaming_w.png": 37998,
	"./fortuna45/PlatipusGaming.png": 18598,
	"./fortuna45/PlayAceGaming.png": 75641,
	"./fortuna45/PlaysonGaming.png": 15552,
	"./fortuna45/PopOkGaming.png": 25905,
	"./fortuna45/PopiplayGaming.png": 54334,
	"./fortuna45/PragmaticPlayGaming.png": 28896,
	"./fortuna45/ProspectGames.png": 71316,
	"./fortuna45/RedRakeGaming.png": 87468,
	"./fortuna45/RedTigerGaming.png": 37212,
	"./fortuna45/RedTigerGamingg.png": 89609,
	"./fortuna45/RedTigerGaminggg.png": 8514,
	"./fortuna45/RedstoneGaming.png": 46402,
	"./fortuna45/ReligaGaming.png": 99092,
	"./fortuna45/RetroGaming.png": 63462,
	"./fortuna45/RocketManGaming.png": 22402,
	"./fortuna45/RubyPlayGaming.png": 73196,
	"./fortuna45/SAGaming.png": 88234,
	"./fortuna45/SimplePlayGaming.png": 49910,
	"./fortuna45/SkyWindgroupGaming.png": 57652,
	"./fortuna45/SlotopiaGaming.png": 61033,
	"./fortuna45/SmartsoftGaming.png": 50585,
	"./fortuna45/Smartsoft_Gaming_bw.png": 63280,
	"./fortuna45/SpearheadGaming.png": 59215,
	"./fortuna45/Spearhead_bw.png": 55988,
	"./fortuna45/SpinomenalGaming.png": 54200,
	"./fortuna45/SpinomenalGamingg.png": 54517,
	"./fortuna45/Spinomenal_w.png": 67965,
	"./fortuna45/SpribeGaming.png": 33203,
	"./fortuna45/TaDaGaming.png": 14406,
	"./fortuna45/TipTopGaming.png": 38942,
	"./fortuna45/TurboGamesGaming.png": 97223,
	"./fortuna45/TvBetGaming.png": 73785,
	"./fortuna45/VGOPlayGaming.png": 48364,
	"./fortuna45/VivoGaming.png": 57140,
	"./fortuna45/VivoGamingg.png": 40817,
	"./fortuna45/VoltEntertainment.png": 89088,
	"./fortuna45/WazdanGaming.png": 77145,
	"./fortuna45/X-UpGaming.png": 13236,
	"./fortuna45/YggdrasilGaming.png": 21076,
	"./fortuna45/YggdrasilGaming_bw.png": 82544,
	"./fortuna45/YoloPlayGaming.png": 78775,
	"./fortuna45/ailivecasino.png": 16740,
	"./fortuna45/apollo.png": 74356,
	"./fortuna45/apollo_games.png": 87364,
	"./fortuna45/aviator.png": 21751,
	"./fortuna45/aviatrix.png": 4887,
	"./fortuna45/awc.png": 19798,
	"./fortuna45/betsoft.png": 46476,
	"./fortuna45/bigpot.png": 70290,
	"./fortuna45/blueprint_gaming.png": 67026,
	"./fortuna45/booongo.png": 1560,
	"./fortuna45/btg.png": 95412,
	"./fortuna45/cq9.png": 33824,
	"./fortuna45/ct855.png": 90380,
	"./fortuna45/dreamgaming.png": 20663,
	"./fortuna45/dreamtech.png": 36372,
	"./fortuna45/eclipse.png": 89730,
	"./fortuna45/egt.png": 71765,
	"./fortuna45/egtdigital.png": 21437,
	"./fortuna45/epicwin.png": 58526,
	"./fortuna45/evolution_gaming.png": 32344,
	"./fortuna45/evoplay.png": 6419,
	"./fortuna45/ezugi.png": 899,
	"./fortuna45/fachai.png": 96185,
	"./fortuna45/fatpanda.png": 48034,
	"./fortuna45/ftv.png": 53817,
	"./fortuna45/gaminator.png": 66873,
	"./fortuna45/goldenrace.png": 46701,
	"./fortuna45/greentube.png": 80602,
	"./fortuna45/habanero.png": 54961,
	"./fortuna45/igt.png": 50081,
	"./fortuna45/intouch-games.png": 5977,
	"./fortuna45/jetx.png": 37294,
	"./fortuna45/jili.png": 62227,
	"./fortuna45/kagaming.png": 62962,
	"./fortuna45/kajot.png": 29842,
	"./fortuna45/konami.png": 27998,
	"./fortuna45/live22.png": 88891,
	"./fortuna45/merkur.png": 99595,
	"./fortuna45/microgaming.png": 97098,
	"./fortuna45/mrslotty.png": 61097,
	"./fortuna45/n2.png": 36465,
	"./fortuna45/novomatic.png": 9171,
	"./fortuna45/only-play.png": 36324,
	"./fortuna45/pgsoft.png": 79978,
	"./fortuna45/playson.png": 47551,
	"./fortuna45/playstar.png": 65371,
	"./fortuna45/portomaso.png": 14097,
	"./fortuna45/pragmatic.png": 97989,
	"./fortuna45/quickspin.png": 46108,
	"./fortuna45/reelkingdom.png": 58706,
	"./fortuna45/rich88.png": 57463,
	"./fortuna45/rocketman.png": 48477,
	"./fortuna45/scientific_games.png": 67234,
	"./fortuna45/sexygaming.png": 17575,
	"./fortuna45/slotopia.png": 72406,
	"./fortuna45/spadegaming.png": 47425,
	"./fortuna45/spribe.png": 52996,
	"./fortuna45/toptrendgaming.png": 8808,
	"./fortuna45/vision.png": 84673,
	"./fortuna45/vivo.png": 71059,
	"./fortuna45/wmcasino.png": 22776,
	"./fortuna45/wmg.png": 48926,
	"./fortuna45/worldentertainment.png": 87551,
	"./fortuna45/wowgaming.png": 64087,
	"./fortuna45/yeebet.png": 41433,
	"./fundist/GameArt_m.jpg": 85465,
	"./fundist/Upgaming_m.jpg": 27958,
	"./fundist/XPG-transparent.png": 92874,
	"./fundist/ae-sexy-logo.png": 80600,
	"./fundist/atmosfera-logo.png": 41044,
	"./fundist/evoplay_logo.png": 96594,
	"./fundist/lucky-streak.png": 9929,
	"./fundist/novomatic-1-line-logo-white.png": 11797,
	"./fundist/spribe-black.png": 9285,
	"./fundist/wm_logo-440x155.png": 6150,
	"./gameart.png": 28615,
	"./gaminator.png": 59814,
	"./gasea/AdvantPlay.png": 5804,
	"./gasea/Alize_Slots.png": 44439,
	"./gasea/AvatarUX.png": 14748,
	"./gasea/BNG.png": 81337,
	"./gasea/Big_Gaming.png": 30414,
	"./gasea/CG.png": 8226,
	"./gasea/CP_Games.png": 64277,
	"./gasea/Cockfight6.png": 69528,
	"./gasea/Crystal.png": 64020,
	"./gasea/DB_Slots.png": 71100,
	"./gasea/GASEA_Thunderkick.png": 94418,
	"./gasea/GTF.png": 45007,
	"./gasea/JDB.png": 33870,
	"./gasea/KY_Poker.png": 74826,
	"./gasea/Lets_Go.png": 27665,
	"./gasea/PlayNGo.png": 14168,
	"./gasea/Relax_Gaming.png": 7722,
	"./gasea/The_Better_Platform.png": 65610,
	"./gasea/WinfinityGaming.png": 99010,
	"./gasea/YellowBatGaming.png": 14636,
	"./gasea/amatic.png": 19425,
	"./gasea/elcasino.png": 51870,
	"./gasea/habanero.png": 12148,
	"./gasea/in-out.png": 54054,
	"./gasea/kingmidas.png": 48787,
	"./gasea/vivolive.png": 35880,
	"./gasea/vplus.png": 56660,
	"./gasea/yoriginal-games.png": 39468,
	"./greentube.png": 19049,
	"./habanero.png": 45664,
	"./igrosoft.png": 3249,
	"./igt.png": 73830,
	"./iron_dog.png": 16209,
	"./isoftbet.png": 96914,
	"./kajot.png": 54989,
	"./leap.png": 57626,
	"./live/19.png": 58161,
	"./live/19.webp": 23483,
	"./live/480.png": 45359,
	"./live/480.webp": 27703,
	"./live/537.png": 98872,
	"./live/537.webp": 24226,
	"./live/668.png": 85599,
	"./live/668.webp": 16699,
	"./live/absolute.webp": 93112,
	"./live/evolution.webp": 95982,
	"./live/ezugi.webp": 40489,
	"./live/pragmatic.webp": 42643,
	"./merkur.png": 8314,
	"./merkur.svg": 31884,
	"./microgaming.png": 40429,
	"./netent.png": 49340,
	"./noble.png": 20794,
	"./not.png": 15765,
	"./novomatic.png": 50600,
	"./octavian.png": 86749,
	"./platipus.png": 63168,
	"./play_n_go.png": 95440,
	"./playson.png": 13080,
	"./playtech.png": 37970,
	"./pragmatic.png": 21966,
	"./pragmatic_play.png": 77373,
	"./pragmatic_play_live.png": 84980,
	"./quickspin.png": 20599,
	"./racing.png": 12842,
	"./red_rake.png": 35919,
	"./rubyplay.png": 96162,
	"./scientific_games.png": 77551,
	"./skywind.png": 67039,
	"./smartsoft.png": 28913,
	"./spinomenal.png": 98038,
	"./spribe.png": 70265,
	"./super_keno.png": 177,
	"./timeless/3Oaks_logo_2_w.png": 98485,
	"./timeless/3Oaks_logo_w.png": 35618,
	"./timeless/3Oaks_logo_white.png": 20258,
	"./timeless/7777_logo_w.png": 51689,
	"./timeless/7mojos_logo.png": 20828,
	"./timeless/Absolute_logo_w_2.png": 1119,
	"./timeless/Aviator_logo_1.png": 31225,
	"./timeless/BF_GAMES_LOGO_w.png": 27333,
	"./timeless/Booming.png": 51842,
	"./timeless/CT_Interactive_logo_green.png": 30199,
	"./timeless/EAGaming_logo.png": 9848,
	"./timeless/Endorphina_Logo_White_Text.png": 16013,
	"./timeless/EvoPlay_logo_w.png": 44203,
	"./timeless/Ezugi_Logo_white copy.png": 69876,
	"./timeless/Ezugi_Logo_white.png": 11963,
	"./timeless/FG_bw.png": 96440,
	"./timeless/Galaxsys_logo-blue-RGB-01.png": 53768,
	"./timeless/Habanero_Logo_w.png": 29837,
	"./timeless/Iconix_Interactive_logo-01.png": 8442,
	"./timeless/ImaginLive_logo_bw.png": 76720,
	"./timeless/JetX_logo.png": 69166,
	"./timeless/KAg_logo_w.png": 79959,
	"./timeless/MacawGamingTextLogoWhite.png": 50404,
	"./timeless/Mancala_logo_white.png": 58966,
	"./timeless/Netend_logo_white.png": 62581,
	"./timeless/NolimitCity_white.png": 97896,
	"./timeless/PGSoft_logo_white.png": 22592,
	"./timeless/PP_Logo_On.png": 62703,
	"./timeless/PlatinGaming_white.png": 85542,
	"./timeless/Platipus_white.png": 33855,
	"./timeless/Playson_logo-w.png": 79741,
	"./timeless/Playson_logo-white.png": 31981,
	"./timeless/PopOk_Vector_02.png": 27361,
	"./timeless/RedTiger_Red2.png": 47837,
	"./timeless/RedTiger_White2.png": 76175,
	"./timeless/Religa_White.png": 46145,
	"./timeless/RocketMan_logo.png": 91187,
	"./timeless/SMARSOFT_LOGO_White.png": 69942,
	"./timeless/SkyWindGroup_Logo2021.png": 7548,
	"./timeless/Spinomenal_logo.png": 67257,
	"./timeless/Spribe.png": 41148,
	"./timeless/TurboGames_logo_white.png": 86074,
	"./timeless/VivoGaming_Gold_Landscape.png": 4105,
	"./timeless/big_time.svg": 59540,
	"./timeless/evolution_logo_online_white_1000x194 copy.png": 8493,
	"./timeless/evolution_logo_online_white_1000x194.png": 17304,
	"./timeless/filsgame.png": 10515,
	"./timeless/logotype.png": 12776,
	"./timeless/netgame.png": 14842,
	"./timeless/not.png": 71266,
	"./timeless/onetouch_white_live.png": 84021,
	"./timeless/retrobet.png": 42508,
	"./timeless/tv_bet_final_logo_w.png": 44272,
	"./virtual.png": 21447,
	"./wazdan.png": 7851,
	"./wm.png": 5648,
	"./xplosive.png": 58192,
	"./yggdrasil.png": 15892,
	"./zeus_play.png": 15214
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64062;